import React from 'react';
import { useTranslatedContent } from '../../i18n/hooks/useTranslatedContent';
import Logo from './Logo';
import CompanyHeader from './description/CompanyHeader';
import FeatureGrid from './description/FeatureGrid';
import WhyChooseUs from './description/WhyChooseUs';

const CompanyDescription = () => {
  const { t } = useTranslatedContent('company');

  return (
    <div className="bg-gradient-to-b from-white to-gray-50 py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <CompanyHeader 
          title={t('title')}
          subtitle={t('subtitle')}
        />
        
        <FeatureGrid 
          features={t('features', { returnObjects: true })} 
        />

        <WhyChooseUs 
          title={t('whyUs.title')}
          points={t('whyUs.points', { returnObjects: true })}
        />
      </div>
    </div>
  );
};

export default CompanyDescription;